import { useState, useEffect } from 'react';
import { axiosInstance, API } from '../App';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Clock, User, BookOpen } from 'lucide-react';

const RecentActivity = () => {
  const [recentNotes, setRecentNotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRecentNotes();
  }, []);

  const fetchRecentNotes = async () => {
    try {
      const response = await axiosInstance.get(`${API}/notes`);
      // Get last 5 notes
      setRecentNotes(response.data.slice(0, 5));
    } catch (error) {
      console.error('Failed to fetch recent notes:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 60) {
      return `${diffMins} min${diffMins !== 1 ? 's' : ''} ago`;
    } else if (diffHours < 24) {
      return `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
    } else if (diffDays < 7) {
      return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
    } else {
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }
  };

  if (loading) {
    return (
      <Card className="beast-card">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 title-gold">
            <Clock className="h-5 w-5" />
            Recent Activity
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-slate-300 text-center py-4">Loading...</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="beast-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 title-gold">
          <Clock className="h-5 w-5" />
          Recent Activity
        </CardTitle>
      </CardHeader>
      <CardContent>
        {recentNotes.length === 0 ? (
          <p className="text-slate-300 text-center py-4">No recent activity</p>
        ) : (
          <div className="space-y-3">
            {recentNotes.map((note) => (
              <div
                key={note.id}
                className="p-3 bg-black/40 rounded-lg border border-slate-700 hover:border-yellow-800 transition-colors"
                data-testid={`recent-note-${note.id}`}
              >
                <div className="flex items-start justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <BookOpen className="h-4 w-4 title-gold flex-shrink-0" />
                    <span className="font-medium text-slate-100">{note.client_name}</span>
                  </div>
                  <span className="text-xs text-slate-400">{formatDate(note.created_at)}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-slate-300 mb-1">
                  <User className="h-3 w-3" />
                  <span className="font-medium">{note.booker_name}</span>
                </div>
                <p className="text-sm text-slate-300 line-clamp-2">{note.mistake_description}</p>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default RecentActivity;
